import _extends from "@babel/runtime/helpers/extends";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { EmbersBaseSwitch } from './baseSwitch';
import { createTableSwitchTheme } from './switchStyles';
import { useIntl } from 'react-intl';
export var EmbersTableSwitch = function EmbersTableSwitch(props) {
  var intl = useIntl();
  var tableSwitchTheme = createTableSwitchTheme(props.type);
  var labelOn, labelOff;
  if (props.type === 'filter') {
    labelOn = intl.formatMessage({
      id: 'embers.toggle.iconLabel.search',
      defaultMessage: 'Search table'
    });
    labelOff = intl.formatMessage({
      id: 'embers.toggle.iconLabel.filter',
      defaultMessage: 'Filter table'
    });
  } else {
    labelOn = intl.formatMessage({
      id: 'embers.toggle.iconLabel.list',
      defaultMessage: 'List'
    });
    labelOff = intl.formatMessage({
      id: 'embers.toggle.iconLabel.card',
      defaultMessage: 'Card'
    });
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: tableSwitchTheme
  }, /*#__PURE__*/React.createElement(EmbersBaseSwitch, _extends({}, props, {
    ariaLabelOn: labelOn,
    ariaLabelOff: labelOff
  })));
};